/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/static-components */
import React, {useState, Fragment, useMemo, memo, useCallback} from "react";
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {
  Col,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Media,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import {FaBars, FaUser, FaUserAlt} from "react-icons/fa";
import {IoLogOutOutline} from "react-icons/io5";
import {MdSupport} from "react-icons/md";
import {useMediaQuery} from "react-responsive";
import zeusLogo from "../../assets/img/brand/zeus_logo.png";
import zeusIcon from "../../assets/img/brand/zeus_icon.png";
import {getOrganizationImages} from "../../redux/Selectors/root.selector";
import NotificationMenu from "../Notification/NotificationMenu";
import ProtectedContent from "../protectedContent";
import DropdownLink from "./dropdownLink";
import NormalLink from "./normalLink";
import {logout} from "../../service/logout";
import {sideBarRoutes} from "../../routes";
import {getIsCustomerSelected} from "../../redux/Selectors/customers.selectors";
import "./sidebar.scss";

const Sidebar = () => {
  const navigate = useNavigate();
  const [collapseOpen, setCollapseOpen] = useState(false);
  const isMobile = useMediaQuery({query: "(max-width: 659px)"});
  const isCustomerSelected = useSelector(getIsCustomerSelected);
  const {logoImg} = useSelector(getOrganizationImages);

  const routes = useMemo(() => {
    return sideBarRoutes(isCustomerSelected);
  }, [isCustomerSelected]);

  const handleLogout = () => {
    navigate("/auth/login");
    logout();
    window.location.reload();
  };

  const toggleCollapse = () => {
    setCollapseOpen(!collapseOpen);
  };

  const closeCollapse = useCallback(() => {
    setCollapseOpen(false);
  }, []);

  const CreateLinks = () => {
    return (
      <Fragment>
        {routes.map((route, key) => {
          const {linkType = "default", ...rest} = route;
          return (
            <Fragment key={key}>
              {linkType === "dropdown" ? (
                <DropdownLink closeCollapse={closeCollapse} {...rest} />
              ) : (
                <NormalLink closeCollapse={closeCollapse} {...rest} />
              )}
            </Fragment>
          );
        })}
      </Fragment>
    );
  };

  return (
    <>
      {!isMobile ? (
        <div id="sidenav-main">
          <div className="sidebar-image-container">
            <img src={logoImg || zeusLogo} alt={"LOGO"} className="sidebar-brand-img" />
          </div>
          <div className="sidebar-route-container">
            <CreateLinks />
          </div>
          <div className="copyright-container">
            <div className="zeus-brand-container">
              <div className="sidebar-footer-divider" />
              <img src={zeusIcon} alt={"Zeus Icon"} className="zeus-brand-icon" />
              <div className="sidebar-footer-divider" />
            </div>
            <div className="copyright-text d-flex justify-content-center">
              © Energy Resource Products, LLC
            </div>
          </div>
        </div>
      ) : (
        <div id="mobile-sidebar">
          <div className="mobile-sidebar-image-container">
            <img
              src={logoImg || zeusLogo}
              alt={"Logo"}
              className="mobile-sidebar-brand-img"
            />
          </div>
          <ProtectedContent perms={["view_notification"]}>
            <div className="sidebar-notification-container">
              <NotificationMenu />
            </div>
          </ProtectedContent>
          <div className="sidebar-profile-dropdown">
            <UncontrolledDropdown nav>
              <DropdownToggle data-cy={"sidebar-menu"} nav>
                <Media className="align-items-center profile">
                  <span
                    className="avatar avatar-sm rounded-circle"
                    style={{
                      border: "1px solid #00AFFF",
                    }}
                  >
                    <FaUserAlt className="profile-main" />
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem
                  to="/app/user-profile"
                  tag={Link}
                  data-cy={"sidebar-profile"}
                >
                  <FaUser />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem
                  href="https://support.energyresourceproducts.com"
                  target="_blank"
                >
                  <MdSupport />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={handleLogout} data-cy={"sidebar-logout"}>
                  <IoLogOutOutline />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <div
            className="collapse-toggler"
            id="navbar-collapse-main"
            onClick={toggleCollapse}
          >
            <FaBars className="navbar-toggler-icon" />
          </div>
          <Collapse navbar isOpen={collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <Link to="/app/home">
                    <img alt={"Logo"} src={logoImg || zeusLogo} />
                  </Link>
                </Col>
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    id={"navbar-collapse-close"}
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <div className="mobile-sidebar-route-container">
              <CreateLinks />
            </div>
            {/* Divider */}
            <hr className="my-3" />
          </Collapse>
        </div>
      )}
    </>
  );
};

export default memo(Sidebar);
